import React from 'react';

export const Footer = () => {
  return (
    <div className='footer  w-100'>
      <div className='footer-container mt-10 d-flex justify-content-between align-items-center'>
        <img className='login_header_logo' src={'/img/edraak_logo.png'} />

        <div className='policies'>
          <a href='https://edraakonline.com/terms-and-condition/' className='policy'>
            Terms of Use
          </a>
          <a href='https://edraakonline.com/privacy-policy/' className='policy'>
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  );
};
